import React from 'react';

import Modal from "../../../component/modal/ModalTemplate";
import PaginationComponent from "../../../component/table/Pagination";
import { SECONDARY_BTN, SMALL_PRIMARY_BTN, SMALL_DANGER_BTN, FOOTER_CENTER, TH, TD } from "./modalStyle";

interface PhoneListItem {
    uid: number;
    name: string;
    listStr: string;
}

interface PhoneListModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    page: number;
    size: number;
    total: number;
    list: PhoneListItem[];
    handlePageChange: (event: unknown, value: number) => void;
    openUpdateModal: () => void;
    selectAction: (uid: number) => void;
    deleteAction: (uid: number) => void;
}

const PhoneListModal: React.FC<PhoneListModalProps> = ({
    isOpen, onRequestClose, page, size, total, list,
    handlePageChange, openUpdateModal, selectAction, deleteAction,
}) => {
    const handleUpdateButtonClick = (uid: number) => {
        onRequestClose();
        openUpdateModal();
        selectAction(uid);
    };

    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="전화번호 목록 보기"
            className="react-full-modal"
        >
            <div className="modal-body tw-max-h-[500px] tw-overflow-y-auto">
                <div className="tw-py-2 tw-text-sm tw-text-[#495057]">총 {total} 건</div>
                <div className="tw-overflow-x-auto">
                    <table className="tw-w-full tw-border-collapse tw-text-sm">
                        <thead>
                            <tr>
                                <th className={TH}>번호</th>
                                <th className={TH}>전화번호명</th>
                                <th className={TH}>전화번호</th>
                                <th className={TH}>관리</th>
                            </tr>
                        </thead>
                        <tbody>
                            {total === 0 && (
                                <tr>
                                    <td className={`${TD} tw-py-4 tw-text-center tw-text-[#A0A0A0]`} colSpan={4}>조건 설정 후 조회 버튼을 클릭해주세요.</td>
                                </tr>
                            )}
                            {list.map((item, idx) => (
                                <tr key={idx}>
                                    <td className={`${TD} tw-text-center`}>{idx + 1}</td>
                                    <td className={TD}>{item.name}</td>
                                    <td className={TD}>{item.listStr}</td>
                                    <td className={`${TD} tw-text-center`}>
                                        <button type="button" className={SMALL_PRIMARY_BTN} onClick={() => handleUpdateButtonClick(item.uid)}>수정</button>
                                        <button type="button" className={SMALL_DANGER_BTN} onClick={() => deleteAction(item.uid)}>삭제</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <PaginationComponent page={page} total={total} sizePerPage={size} handleChange={handlePageChange} />
            </div>
            <div className={FOOTER_CENTER}>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>닫기</button>
            </div>
        </Modal>
    );
};

export default PhoneListModal;
